// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"c20426d9","283":"6e487ed6"}[chunkId] + ".chunk.css";
};